// Static fleet configuration for the SCADA prototype.
// Scope = ТОВ ТЕПЛА own portfolio: 5 live SES + Лучки (commissioning).
// EIC W codes from ТОВ ТЕПЛА/ukrenergo/MMS. `skoApplicable=false` for Tabaki
// (no curtailment contract with Ukrenergo — not in lms.ua.energy).

export interface StationConfig {
  id: string;
  name: string;
  legalEntity: string;
  region: string;
  eicW: string | null;
  acCapacityKw: number;     // installed inverter (AC) capacity
  dcCapacityKwp: number;
  inverterCount: number;
  hasBess: boolean;
  bessCapacityKwh?: number;
  skoApplicable: boolean;   // subject to Ukrenergo curtailment (СКО)
  ownership: 'own' | 'commissioning';
  marketModel: 'guaranteed_buyer' | 'ppa' | 'other';
}

export const STATIONS: StationConfig[] = [
  {
    id: 'bolgrad',
    name: 'Болград Еліос',
    legalEntity: 'ТОВ Болград Еліос',
    region: 'Одеська',
    eicW: '62W106817565247Y',
    acCapacityKw: 4936,
    dcCapacityKwp: 6200,
    inverterCount: 111,
    hasBess: true,
    bessCapacityKwh: 2000,
    skoApplicable: true,
    ownership: 'own',
    marketModel: 'guaranteed_buyer',
  },
  {
    id: 'tabaki',
    name: 'Табаки',
    legalEntity: 'ТОВ Болград Еліос',
    region: 'Одеська',
    eicW: '62W9281391595523',
    acCapacityKw: 1000,
    dcCapacityKwp: 1300,
    inverterCount: 8,
    hasBess: false,
    skoApplicable: false, // немає договору СКО, не у Гарпоку
    ownership: 'own',
    marketModel: 'other',
  },
  {
    id: 'prometheus',
    name: 'Покров (Прометей ЕТГ)',
    legalEntity: 'ТОВ Прометей ЕТГ',
    region: 'Дніпропетровська',
    eicW: '62W143852239726U',
    acCapacityKw: 4238,
    dcCapacityKwp: 5300,
    inverterCount: 70,
    hasBess: false,
    skoApplicable: true,
    ownership: 'own',
    marketModel: 'guaranteed_buyer',
  },
  {
    id: 'nickelios',
    name: 'Нікеліос',
    legalEntity: 'ТОВ Нікеліос',
    region: 'Дніпропетровська',
    eicW: '62W642273610034V',
    acCapacityKw: 3600,
    dcCapacityKwp: 4500,
    inverterCount: 19,
    hasBess: false,
    skoApplicable: true,
    ownership: 'own',
    marketModel: 'guaranteed_buyer',
  },
  {
    id: 'nikopol',
    name: 'Нікополь-Еліос',
    legalEntity: 'ТОВ Нікополь-Еліос',
    region: 'Дніпропетровська',
    eicW: '62W159160687476F',
    acCapacityKw: 12100,
    dcCapacityKwp: 15100,
    inverterCount: 64,
    hasBess: false,
    skoApplicable: true,
    ownership: 'own',
    marketModel: 'guaranteed_buyer',
  },
  {
    id: 'luchky',
    name: 'Лучки',
    legalEntity: 'ТОВ ТЕПЛА',
    region: 'Одеська',
    eicW: '62Z7937187569108',
    acCapacityKw: 15040,
    dcCapacityKwp: 22352,
    inverterCount: 200,
    hasBess: false,
    skoApplicable: true,
    ownership: 'commissioning',
    marketModel: 'guaranteed_buyer',
  },
];
